export const COUNTRY_CODES: { [key: string]: string } = {
  "+93": "af",
  "+355": "al",
  "+213": "dz",
  "+1": "us",
  "+376": "ad",
  "+244": "ao",
  "+54": "ar",
  "+374": "am",
  "+61": "au",
  "+43": "at",
  "+994": "az",
  "+973": "bh",
  "+880": "bd",
  "+375": "by",
  "+32": "be",
  "+229": "bj",
  "+975": "bt",
  "+591": "bo",
  "+387": "ba",
  "+267": "bw",
  "+55": "br",
  "+359": "bg",
  "+226": "bf",
  "+95": "mm",
  "+257": "bi",
  "+855": "kh",
  "+237": "cm",
  "+238": "cv",
  "+236": "cf",
  "+235": "td",
  "+56": "cl",
  "+86": "cn",
  "+57": "co",
  "+269": "km",
  "+242": "cg",
  "+243": "cd",
  "+506": "cr",
  "+225": "ci",
  "+385": "hr",
  "+53": "cu",
  "+357": "cy",
  "+420": "cz",
  "+45": "dk",
  "+253": "dj",
  "+593": "ec",
  "+20": "eg",
  "+503": "sv",
  "+240": "gq",
  "+291": "er",
  "+372": "ee",
  "+251": "et",
  "+679": "fj",
  "+358": "fi",
  "+33": "fr",
  "+241": "ga",
  "+220": "gm",
  "+995": "ge",
  "+49": "de",
  "+233": "gh",
  "+30": "gr",
  "+502": "gt",
  "+224": "gn",
  "+245": "gw",
  "+592": "gy",
  "+509": "ht",
  "+504": "hn",
  "+36": "hu",
  "+354": "is",
  "+91": "in",
  "+62": "id",
  "+98": "ir",
  "+964": "iq",
  "+353": "ie",
  "+972": "il",
  "+39": "it",
  "+81": "jp",
  "+962": "jo",
  "+7": "ru",
  "+254": "ke",
  "+686": "ki",
  "+383": "xk",
  "+965": "kw",
  "+996": "kg",
  "+856": "la",
  "+371": "lv",
  "+961": "lb",
  "+266": "ls",
  "+231": "lr",
  "+218": "ly",
  "+423": "li",
  "+370": "lt",
  "+352": "lu",
  "+261": "mg",
  "+265": "mw",
  "+60": "my",
  "+960": "mv",
  "+223": "ml",
  "+356": "mt",
  "+222": "mr",
  "+230": "mu",
  "+52": "mx",
  "+373": "md",
  "+377": "mc",
  "+976": "mn",
  "+212": "ma",
  "+258": "mz",
  "+264": "na",
  "+977": "np",
  "+31": "nl",
  "+64": "nz",
  "+505": "ni",
  "+227": "ne",
  "+234": "ng",
  "+850": "kp",
  "+47": "no",
  "+968": "om",
  "+92": "pk",
  "+970": "ps",
  "+507": "pa",
  "+675": "pg",
  "+595": "py",
  "+51": "pe",
  "+63": "ph",
  "+48": "pl",
  "+351": "pt",
  "+974": "qa",
  "+40": "ro",
  "+250": "rw",
  "+966": "sa",
  "+221": "sn",
  "+381": "rs",
  "+248": "sc",
  "+232": "sl",
  "+65": "sg",
  "+421": "sk",
  "+386": "si",
  "+252": "so",
  "+27": "za",
  "+82": "kr",
  "+34": "es",
  "+94": "lk",
  "+249": "sd",
  "+597": "sr",
  "+268": "sz",
  "+46": "se",
  "+41": "ch",
  "+963": "sy",
  "+886": "tw",
  "+992": "tj",
  "+255": "tz",
  "+66": "th",
  "+228": "tg",
  "+676": "to",
  "+216": "tn",
  "+90": "tr",
  "+993": "tm",
  "+256": "ug",
  "+380": "ua",
  "+971": "ae",
  "+44": "gb", 
  "+998": "uz",
  "+58": "ve",
  "+84": "vn",
  "+967": "ye",
  "+260": "zm",
  "+263": "zw"
};
